import React from "react"
import PropTypes from "prop-types"
import { editLink } from "./edit-button.module.scss"
import icon from "./edit-icon.png"
//-----------------------Parent component---------------------------//

const EditButton = ({ addedClass, link }) => {
  const baseUrl = process.env.GATSBYSIDE_DRUPAL_URL
  if (process.env.TRIGGER_TYPE === "preview") {
    return (
      <>
        <div className={editLink + " " + addedClass}>
          <a href={baseUrl + link} target="_blank" rel="noreferrer">
            <img src={icon} />
          </a>
        </div>
      </>
    )
  }
  return null
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//
EditButton.propTypes = {
  link: PropTypes.string,
  addedClass: PropTypes.string,
}
//-----------------------Prop-Types---------------------------//

export default EditButton
